import { Box, InfoIcon, Text, TextButton } from '@wix/design-system';
import { Check } from '@wix/wix-ui-icons-common/lazy';
import React from 'react';
const ROW_COLORS = {
  '--wds-info-icon-fill': 'var(--wds-color-text-standard-primary)',
  '--wds-info-icon-fill-hover': 'var(--wds-color-text-standard-primary)'
};
export const FeatureRow = _ref => {
  var _feature$content, _feature$content2, _feature$content3, _feature$values, _feature$metadata;
  let {
    feature,
    productId,
    t,
    Trans
  } = _ref;
  const nameKey = ((_feature$content = feature.content) == null || (_feature$content = _feature$content.name) == null ? void 0 : _feature$content.translationKey) ?? '';
  const tooltipKey = (_feature$content2 = feature.content) == null || (_feature$content2 = _feature$content2.tooltip) == null ? void 0 : _feature$content2.translationKey;
  const descriptionKey = (_feature$content3 = feature.content) == null || (_feature$content3 = _feature$content3.description) == null ? void 0 : _feature$content3.translationKey;
  const valueKey = (_feature$values = feature.values) == null || (_feature$values = _feature$values[productId]) == null || (_feature$values = _feature$values.value) == null ? void 0 : _feature$values.translationKey;
  const tooltipUrlKey = (_feature$metadata = feature.metadata) == null ? void 0 : _feature$metadata.tooltipUrlKey;
  const translationTags = React.useMemo(() => ({
    ellipsis: /*#__PURE__*/React.createElement(React.Fragment, null),
    url: /*#__PURE__*/React.createElement(TextButton, {
      as: "a",
      target: "_blank",
      underline: "onHover",
      size: "small",
      href: t(tooltipUrlKey ?? '')
    })
  }), [t, tooltipUrlKey]);
  return /*#__PURE__*/React.createElement(Box, {
    display: "grid",
    gridTemplateColumns: "1.3fr 1fr",
    minHeight: "48px",
    style: ROW_COLORS
  }, /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "middle",
    align: "space-between",
    gap: "12px",
    paddingTop: "6px",
    paddingBottom: "6px",
    paddingInlineEnd: "18px"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: nameKey,
    components: translationTags,
    values: {
      domainName: undefined
    }
  })), descriptionKey && /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    secondary: true
  }, t(descriptionKey))), tooltipKey && /*#__PURE__*/React.createElement(InfoIcon, {
    size: "small",
    ariaLabel: t(nameKey, {
      domainName: undefined
    }),
    content: /*#__PURE__*/React.createElement(Trans, {
      i18nKey: tooltipKey,
      components: translationTags,
      values: {
        domainName: undefined
      }
    })
  })), /*#__PURE__*/React.createElement(Box, {
    align: "center",
    verticalAlign: "middle",
    textAlign: "center",
    paddingTop: "6px",
    paddingBottom: "6px"
  }, valueKey ? /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, t(valueKey)) : /*#__PURE__*/React.createElement(Check, {
    "aria-hidden": true
  })));
};
//# sourceMappingURL=FeatureRow.js.map